import { useEffect, useState } from "react";
import { History } from "lucide-react";
import ProductCard from "@/components/ProductCard";
import { getRecentlyViewed } from "@/lib/recentlyViewed";

export default function RecentlyViewed({ currentId }) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    setItems(getRecentlyViewed().filter((p) => p.id !== currentId));
  }, [currentId]);

  if (items.length === 0) return null;

  return (
    <section data-testid="recently-viewed" className="border-t border-white/10 pt-12 mt-4">
      <div className="flex items-center gap-3 mb-6">
        <History className="w-5 h-5 text-primary" />
        <h2 className="font-anton text-2xl sm:text-3xl uppercase tracking-tight text-white">
          Recently viewed
        </h2>
      </div>
      <div className="flex gap-3 sm:gap-5 overflow-x-auto pb-4 -mx-1 px-1 no-scrollbar snap-x">
        {items.map((p, i) => (
          <div key={p.id} className="snap-start shrink-0 w-[45%] sm:w-56 md:w-60">
            <ProductCard product={p} index={i} />
          </div>
        ))}
      </div>
    </section>
  );
}
